export default "__VITE_ASSET__CuFmMXxd__"